unit ImportData;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Data.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  WEBLib.DB,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  WEBLib.WebCtrls, WebForm.Core,
  Grid.Plugins, WEBLib.Lists,
  smx.webcore.types, WEBLib.ExtCtrls;

type
  TImportDataList = class(TCoreWebForm)
    ImportDonationsTable: TDBTableControl;
    ImportDonationSource: TDataSource;
    ImportDonationData: TXDataWebDataSet;
    ImportDonationDataId: TIntegerField;
    ImportDonationDataDateAdded: TDateTimeField;
    ImportDonationDataAddedBy: TIntegerField;
    ImportDonationDataLastUpdatedBy: TIntegerField;
    ImportDonationDataLastUpdated: TDateTimeField;
    ImportDonationDataTitle: TStringField;
    ImportDonationDataFirstName: TStringField;
    ImportDonationDataMiddleName: TStringField;
    ImportDonationDataLastName: TStringField;
    ImportDonationDataSuffix: TStringField;
    ImportDonationDataAdd1: TStringField;
    ImportDonationDataAdd2: TStringField;
    ImportDonationDataAdd3: TStringField;
    ImportDonationDataCity: TStringField;
    ImportDonationDataPostCode: TStringField;
    ImportDonationDataEmail: TStringField;
    ImportDonationDataMobile: TStringField;
    ImportDonationDataTelephone: TStringField;
    ImportDonationDataMatchHash: TStringField;
    ImportDonationDataContactByPhone: TBooleanField;
    ImportDonationDataContactByPost: TBooleanField;
    ImportDonationDataContactByText: TBooleanField;
    ImportDonationDataContactByEmail: TBooleanField;
    ImportDonationDataDOB: TDateField;
    ImportDonationDataEmailStatus: TStringField;
    ImportDonationDataLatitude: TFloatField;
    ImportDonationDataLongitude: TFloatField;
    ImportDonationDataExternalId: TStringField;
    ImportDonationDataCountryCode: TStringField;
    ImportDonationDataClaimStatus: TStringField;
    ImportDonationDataCharityTenant: TStringField;
    ImportDonationDataImportState: TStringField;
    ImportDonationDataErrorText: TStringField;
    ImportDonationDataImportBatchId: TIntegerField;
    ImportDonationDataSponsored: TBooleanField;
    ImportDonationDataDonationDate: TDateTimeField;
    ImportDonationDataGiftAid: TFloatField;
    ImportDonationDataAmount: TFloatField;
    ImportDonationDataExternalDonationId: TStringField;
    ImportDonationDataMatchedPerson: TIntegerField;
    ImportDonationDataHearingStatus: TStringField;
    ImportDonationDataVisualStatus: TStringField;
    ImportDonationDataMobilityStatus: TStringField;
    ImportDonationDataSourceType: TStringField;
    ImportDonationDataCounty: TStringField;
    ImportDonationDataImportId: TIntegerField;
    ImportDonationDataCountry: TStringField;
    PageSizeCombo: TComboBox;
    PaginationInfo: TListControl;
    PaginationInfoLabel: TLabel;
    CloseButton: TButton;
    DeleteDonation: TMessageDlg;
    ShowErrorsOnly: TCheckBox;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormDestroy(Sender: TObject);
    procedure DonationsCloseButtonClick(Sender: TObject);
    procedure ImportDonationDataAfterApplyUpdates(Sender: TDataSet; Info:
        TResolveResults);
    procedure ImportDonationDataAfterDelete(DataSet: TDataSet);
    procedure ImportDonationsTableGetCellChildren(Sender: TObject; ACol, ARow:
        Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure PageSizeComboChange(Sender: TObject);
    procedure ShowErrorsOnlyClick(Sender: TObject);
    procedure ImportDonationDataAfterPost(DataSet: TDataSet);
    procedure CloseButtonClick(Sender: TObject);
  private
    { Private declarations }
    FGridPlugin: TGridPlugin;
    FIdField: string;
    FFilter: string;

    FImportId: Integer;

    procedure SetImportId(const Value: Integer);
    [Async]
    procedure EditRecord(const RecordId: Integer; const AErrorList: string); async;
    [ASync]
    procedure RefreshData; async;
    procedure CreateGridPlugin;
    function CheckOkToDelete(AId: integer):boolean;
    [async]
    procedure DeleteSelectedRecord(RecordId: integer); async;
    function ParseErrorMessage(AErrorList: string):string;

    procedure NotADuplicateRecord(ARecordId: integer);

    [async]
    procedure UpdateImportTotals; async;

  public
    procedure AfterCreated; override;
    property ImportId: Integer write SetImportId;
  protected procedure LoadDFMValues; override; end;

var
  ImportDataList: TImportDataList;

implementation

{$R *.dfm}

uses
  MainDataModule, SMX.Web.Layout.Utils, ImportDataEdit, XData.Web.Client;

procedure TImportDataList.WebFormCreate(Sender: TObject);
begin
  inherited;
  CreateGridPlugin;
end;

procedure TImportDataList.WebFormDestroy(Sender: TObject);
begin
  FGridPlugin.Free;
  inherited;
end;

procedure TImportDataList.CreateGridPlugin;
begin
  FGridPlugin := TGridPlugin.Create(ImportDonationsTable, ImportDonationData, PaginationInfo, PaginationInfoLabel,
    TSortPair.Create(0, sdDesc));
  FGridPlugin.SetPageSize(10);
end;


procedure TImportDataList.AfterCreated;
begin
  inherited;
end;

procedure TImportDataList.DonationsCloseButtonClick(Sender: TObject);
begin
  ModalResult := mrOK;
end;

procedure TImportDataList.EditRecord(const RecordId: Integer; const AErrorList: string);
var
  AForm: TImportDataEditForm;
begin
  AForm := TImportDataEditForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';
    await(TForm, AForm.Load());
    if not ImportDonationData.Locate('Id', RecordId, []) then
    begin
      ShowMessage('The selected record could not be found. Please refresh the list and try again.');
      Exit;
    end;
    AForm.DataSet := ImportDonationData;
    AForm.AfterCreated;
    AForm.ErrorList := AErrorList;
    await(TModalResult, AForm.Execute);
  finally
    if AForm.EditDataApplyUpdates then
    begin
      ImportDonationData.ApplyUpdates;
    end;
    AForm.Free;
    AForm := nil;
    //UpdateImportTotals;
  end;
end;

procedure TImportDataList.ImportDonationDataAfterApplyUpdates(Sender: TDataSet;
    Info: TResolveResults);
begin
  inherited;
  RefreshData;
end;

procedure TImportDataList.ImportDonationsTableGetCellChildren(Sender: TObject;
    ACol, ARow: Integer; AField: TField; AValue: string; AElement:
    TJSHTMLElementRecord);
var
  RecordId: integer;
  Span: THTMLSpan;
  ErrorList: string;
  lErrorMessage: string;

  procedure EditClick(Sender: TObject);
  begin
    EditRecord(TLayoutUtils.GetActionRecordIdInt(Sender), ErrorList);
  end;

  procedure DeleteClick(Sender: TObject);
  begin
    DeleteSelectedRecord(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

  procedure NotADuplicateClick(Sender: TObject);
  begin
    NotADuplicateRecord(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

begin
  if ARow = 0 then
    Exit;

  if (ImportDonationsTable.Columns[ACol].Title = 'Errors') then
  begin
    ErrorList := ImportDonationData.FieldByName('ErrorText').AsString;

    if ErrorList <> '' then
    begin
      lErrorMessage := ParseErrorMessage(ErrorList);
      ImportDonationsTable.Cells[ACol,ARow] := lErrorMessage;
    end;
  end;

  if not (ImportDonationsTable.Columns[ACol].Title = 'Actions') then
  begin
    Exit;
  end;

  RecordId := ImportDonationData.FieldByName('Id').AsInteger;

  if ImportDonationData.FieldByName('ImportState').AsString = 'Error' then
  begin
    ErrorList := ImportDonationData.FieldByName('ErrorText').AsString;

    if Pos('Duplicate', ErrorList) > 0 then
    begin
      Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-user-friends', 'Not Duplicate');
      TLayoutUtils.SetActionRecordId(Span, RecordId);
      Span.OnClick := @NotADuplicateClick;
    end;

    Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-edit', 'Edit');
    TLayoutUtils.SetActionRecordId(Span, RecordId);
    Span.OnClick := @EditClick;
  end;

  Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-trash', 'Delete');
  TLayoutUtils.SetActionRecordId(Span, RecordId);
  Span.OnClick := @DeleteClick;
end;

procedure TImportDataList.PageSizeComboChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(PageSizeCombo.Text), True);
end;

function TImportDataList.ParseErrorMessage(AErrorList: string): string;
var
  lErrorMessage: string;
begin
  lErrorMessage := '';

  if Pos('Firstname', AErrorList) > 0 then
    lErrorMessage := lErrorMessage + 'First Name, ';
  if Pos('Lastname', AErrorList) > 0 then
    lErrorMessage := lErrorMessage + 'Last Name, ';
  if Pos('Address', AErrorList) > 0 then
    lErrorMessage := lErrorMessage + 'Address, ';
  if Pos('Postcode', AErrorList) > 0 then
    lErrorMessage := lErrorMessage + 'Post Code, ';
  if Pos('Country', AErrorList) > 0 then
    lErrorMessage := lErrorMessage + 'Country, ';
  if Pos('OutOfRange', AErrorList) > 0 then
    lErrorMessage := lErrorMessage + 'Date, ';
  if Pos('AmountZero', AErrorList) > 0 then
    lErrorMessage := lErrorMessage + 'Donation, ';
  if Pos('ExtDonorId', AErrorList) > 0 then
    lErrorMessage := lErrorMessage + 'External Donor Id, ';
  if Pos('ExtDonatId', AErrorList) > 0 then
    lErrorMessage := lErrorMessage + 'External Donation Id, ';
  if Pos('Import Duplicate', AErrorList) > 0 then
    lErrorMessage := lErrorMessage + 'Duplicate in this import  ';
  if Pos('Previous Duplicate', AErrorList) > 0 then
    lErrorMessage := lErrorMessage + 'Duplicate of previous import  ';

  Result := Copy(lErrorMessage, 1, Length(lErrorMessage)-2);
end;

procedure TImportDataList.SetImportId(const Value: Integer);
begin
  FImportId := Value;
  FFilter := Format('ImportBatchId eq %d',[FImportId]);

  FGridPlugin.SetPreparedFilter(FFilter);
end;

procedure TImportDataList.RefreshData;
var
  lFilter: string;
begin
  FGridPlugin.Load;
end;

function TImportDataList.CheckOkToDelete(AId: integer):boolean;
begin
end;

procedure TImportDataList.CloseButtonClick(Sender: TObject);
begin
  inherited;
  UpdateImportTotals;
end;

procedure TImportDataList.DeleteSelectedRecord(RecordId: integer);
var
  mr: TModalResult;
begin
  mr := await(TModalResult, DeleteDonation.ShowDialog('Are you sure you want to delete this donation?',
    WEBLib.Dialogs.mtConfirmation, [mbYes, mbNo]));
  if mr = mrYes then
  begin
    try
      if ImportDonationData.Locate('Id', RecordId, []) then
        ImportDonationData.Delete;
    finally

    end;
  end;
end;

procedure TImportDataList.ImportDonationDataAfterDelete(DataSet: TDataSet);
begin
  ImportDonationData.ApplyUpdates;
end;

procedure TImportDataList.ImportDonationDataAfterPost(DataSet: TDataSet);
begin
  inherited;
  ImportDonationData.ApplyUpdates;
end;

procedure TImportDataList.ShowErrorsOnlyClick(Sender: TObject);
begin
  if ShowErrorsOnly.Checked then
  begin
    FFilter := Format('ImportBatchId eq %d AND ImportState eq ''Error''',[FImportId]);
  end
  else
  begin
    FFilter := Format('ImportBatchId eq %d',[FImportId]);
  end;
  FGridPlugin.SetPreparedFilter(FFilter);
end;

procedure TImportDataList.NotADuplicateRecord(ARecordId: integer);
begin
  if ImportDonationData.Locate('Id', ARecordId, []) then
  begin
    ImportDonationData.Edit;
    ImportDonationData.FieldByName('ImportState').AsString := 'Valid';
    ImportDonationData.Post;
  end;
end;

procedure TImportDataList.UpdateImportTotals;
var
  lResponse: TJSObject;
begin
  await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.UpdateImportDataTotal',
    [FImportId]));
end;

procedure TImportDataList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  PaginationInfoLabel := TLabel.Create('PageInfoLabel');
  ImportDonationsTable := TDBTableControl.Create('ImportDonationsTable');
  PageSizeCombo := TComboBox.Create('PageSize');
  PaginationInfo := TListControl.Create('PaginationNumbers');
  CloseButton := TButton.Create('CloseDataButton');
  DeleteDonation := TMessageDlg.Create(Self);
  ShowErrorsOnly := TCheckBox.Create('ShowErrors');
  ImportDonationSource := TDataSource.Create(Self);
  ImportDonationData := TXDataWebDataSet.Create(Self);
  ImportDonationDataId := TIntegerField.Create(Self);
  ImportDonationDataDateAdded := TDateTimeField.Create(Self);
  ImportDonationDataAddedBy := TIntegerField.Create(Self);
  ImportDonationDataLastUpdatedBy := TIntegerField.Create(Self);
  ImportDonationDataLastUpdated := TDateTimeField.Create(Self);
  ImportDonationDataTitle := TStringField.Create(Self);
  ImportDonationDataFirstName := TStringField.Create(Self);
  ImportDonationDataMiddleName := TStringField.Create(Self);
  ImportDonationDataLastName := TStringField.Create(Self);
  ImportDonationDataSuffix := TStringField.Create(Self);
  ImportDonationDataAdd1 := TStringField.Create(Self);
  ImportDonationDataAdd2 := TStringField.Create(Self);
  ImportDonationDataAdd3 := TStringField.Create(Self);
  ImportDonationDataCity := TStringField.Create(Self);
  ImportDonationDataPostCode := TStringField.Create(Self);
  ImportDonationDataEmail := TStringField.Create(Self);
  ImportDonationDataMobile := TStringField.Create(Self);
  ImportDonationDataTelephone := TStringField.Create(Self);
  ImportDonationDataMatchHash := TStringField.Create(Self);
  ImportDonationDataContactByPhone := TBooleanField.Create(Self);
  ImportDonationDataContactByPost := TBooleanField.Create(Self);
  ImportDonationDataContactByText := TBooleanField.Create(Self);
  ImportDonationDataContactByEmail := TBooleanField.Create(Self);
  ImportDonationDataDOB := TDateField.Create(Self);
  ImportDonationDataEmailStatus := TStringField.Create(Self);
  ImportDonationDataLatitude := TFloatField.Create(Self);
  ImportDonationDataLongitude := TFloatField.Create(Self);
  ImportDonationDataExternalId := TStringField.Create(Self);
  ImportDonationDataCountryCode := TStringField.Create(Self);
  ImportDonationDataClaimStatus := TStringField.Create(Self);
  ImportDonationDataCharityTenant := TStringField.Create(Self);
  ImportDonationDataImportState := TStringField.Create(Self);
  ImportDonationDataErrorText := TStringField.Create(Self);
  ImportDonationDataImportBatchId := TIntegerField.Create(Self);
  ImportDonationDataSponsored := TBooleanField.Create(Self);
  ImportDonationDataDonationDate := TDateTimeField.Create(Self);
  ImportDonationDataGiftAid := TFloatField.Create(Self);
  ImportDonationDataAmount := TFloatField.Create(Self);
  ImportDonationDataExternalDonationId := TStringField.Create(Self);
  ImportDonationDataMatchedPerson := TIntegerField.Create(Self);
  ImportDonationDataHearingStatus := TStringField.Create(Self);
  ImportDonationDataVisualStatus := TStringField.Create(Self);
  ImportDonationDataMobilityStatus := TStringField.Create(Self);
  ImportDonationDataSourceType := TStringField.Create(Self);
  ImportDonationDataCounty := TStringField.Create(Self);
  ImportDonationDataImportId := TIntegerField.Create(Self);
  ImportDonationDataCountry := TStringField.Create(Self);

  PaginationInfoLabel.BeforeLoadDFMValues;
  ImportDonationsTable.BeforeLoadDFMValues;
  PageSizeCombo.BeforeLoadDFMValues;
  PaginationInfo.BeforeLoadDFMValues;
  CloseButton.BeforeLoadDFMValues;
  DeleteDonation.BeforeLoadDFMValues;
  ShowErrorsOnly.BeforeLoadDFMValues;
  ImportDonationSource.BeforeLoadDFMValues;
  ImportDonationData.BeforeLoadDFMValues;
  ImportDonationDataId.BeforeLoadDFMValues;
  ImportDonationDataDateAdded.BeforeLoadDFMValues;
  ImportDonationDataAddedBy.BeforeLoadDFMValues;
  ImportDonationDataLastUpdatedBy.BeforeLoadDFMValues;
  ImportDonationDataLastUpdated.BeforeLoadDFMValues;
  ImportDonationDataTitle.BeforeLoadDFMValues;
  ImportDonationDataFirstName.BeforeLoadDFMValues;
  ImportDonationDataMiddleName.BeforeLoadDFMValues;
  ImportDonationDataLastName.BeforeLoadDFMValues;
  ImportDonationDataSuffix.BeforeLoadDFMValues;
  ImportDonationDataAdd1.BeforeLoadDFMValues;
  ImportDonationDataAdd2.BeforeLoadDFMValues;
  ImportDonationDataAdd3.BeforeLoadDFMValues;
  ImportDonationDataCity.BeforeLoadDFMValues;
  ImportDonationDataPostCode.BeforeLoadDFMValues;
  ImportDonationDataEmail.BeforeLoadDFMValues;
  ImportDonationDataMobile.BeforeLoadDFMValues;
  ImportDonationDataTelephone.BeforeLoadDFMValues;
  ImportDonationDataMatchHash.BeforeLoadDFMValues;
  ImportDonationDataContactByPhone.BeforeLoadDFMValues;
  ImportDonationDataContactByPost.BeforeLoadDFMValues;
  ImportDonationDataContactByText.BeforeLoadDFMValues;
  ImportDonationDataContactByEmail.BeforeLoadDFMValues;
  ImportDonationDataDOB.BeforeLoadDFMValues;
  ImportDonationDataEmailStatus.BeforeLoadDFMValues;
  ImportDonationDataLatitude.BeforeLoadDFMValues;
  ImportDonationDataLongitude.BeforeLoadDFMValues;
  ImportDonationDataExternalId.BeforeLoadDFMValues;
  ImportDonationDataCountryCode.BeforeLoadDFMValues;
  ImportDonationDataClaimStatus.BeforeLoadDFMValues;
  ImportDonationDataCharityTenant.BeforeLoadDFMValues;
  ImportDonationDataImportState.BeforeLoadDFMValues;
  ImportDonationDataErrorText.BeforeLoadDFMValues;
  ImportDonationDataImportBatchId.BeforeLoadDFMValues;
  ImportDonationDataSponsored.BeforeLoadDFMValues;
  ImportDonationDataDonationDate.BeforeLoadDFMValues;
  ImportDonationDataGiftAid.BeforeLoadDFMValues;
  ImportDonationDataAmount.BeforeLoadDFMValues;
  ImportDonationDataExternalDonationId.BeforeLoadDFMValues;
  ImportDonationDataMatchedPerson.BeforeLoadDFMValues;
  ImportDonationDataHearingStatus.BeforeLoadDFMValues;
  ImportDonationDataVisualStatus.BeforeLoadDFMValues;
  ImportDonationDataMobilityStatus.BeforeLoadDFMValues;
  ImportDonationDataSourceType.BeforeLoadDFMValues;
  ImportDonationDataCounty.BeforeLoadDFMValues;
  ImportDonationDataImportId.BeforeLoadDFMValues;
  ImportDonationDataCountry.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnDestroy', 'WebFormDestroy');
    PaginationInfoLabel.SetParentComponent(Self);
    PaginationInfoLabel.Name := 'PaginationInfoLabel';
    PaginationInfoLabel.Left := 32;
    PaginationInfoLabel.Top := 413;
    PaginationInfoLabel.Width := 156;
    PaginationInfoLabel.Height := 25;
    PaginationInfoLabel.Caption := 'PaginationInfoLabel';
    PaginationInfoLabel.HeightPercent := 100.000000000000000000;
    PaginationInfoLabel.WidthPercent := 100.000000000000000000;
    ImportDonationsTable.SetParentComponent(Self);
    ImportDonationsTable.Name := 'ImportDonationsTable';
    ImportDonationsTable.Left := 32;
    ImportDonationsTable.Top := 104;
    ImportDonationsTable.Width := 513;
    ImportDonationsTable.Height := 249;
    ImportDonationsTable.HeightStyle := ssAuto;
    ImportDonationsTable.WidthStyle := ssAuto;
    ImportDonationsTable.BorderColor := clSilver;
    ImportDonationsTable.ChildOrder := 4;
    ImportDonationsTable.ElementFont := efCSS;
    ImportDonationsTable.ElementHeaderClassName := 'thead-light';
    ImportDonationsTable.ElementPosition := epIgnore;
    ImportDonationsTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    SetEvent(ImportDonationsTable, Self, 'OnGetCellChildren', 'ImportDonationsTableGetCellChildren');
    ImportDonationsTable.Columns.Clear;
    with ImportDonationsTable.Columns.Add do
    begin
      DataField := 'Id';
      Title := 'Id';
    end;
    with ImportDonationsTable.Columns.Add do
    begin
      DataField := 'FirstName';
      Title := 'Firstname';
    end;
    with ImportDonationsTable.Columns.Add do
    begin
      DataField := 'LastName';
      Title := 'Lastname';
    end;
    with ImportDonationsTable.Columns.Add do
    begin
      DataField := 'DonationDate';
      Title := 'Date';
    end;
    with ImportDonationsTable.Columns.Add do
    begin
      DataField := 'PostCode';
      Title := 'Post Code';
    end;
    with ImportDonationsTable.Columns.Add do
    begin
      DataField := 'Amount';
      Title := 'Amount';
    end;
    with ImportDonationsTable.Columns.Add do
    begin
      DataField := 'ImportState';
      Title := 'State';
    end;
    with ImportDonationsTable.Columns.Add do
    begin
      DataField := 'ErrorText';
      Title := 'Errors';
    end;
    with ImportDonationsTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    ImportDonationsTable.DataSource := ImportDonationSource;
    PageSizeCombo.SetParentComponent(Self);
    PageSizeCombo.Name := 'PageSizeCombo';
    PageSizeCombo.Left := 32;
    PageSizeCombo.Top := 75;
    PageSizeCombo.Width := 145;
    PageSizeCombo.Height := 33;
    PageSizeCombo.ElementClassName := 'form-select';
    PageSizeCombo.ElementPosition := epIgnore;
    PageSizeCombo.HeightStyle := ssAuto;
    PageSizeCombo.HeightPercent := 100.000000000000000000;
    PageSizeCombo.Text := 'PageSize';
    PageSizeCombo.WidthStyle := ssAuto;
    PageSizeCombo.WidthPercent := 100.000000000000000000;
    SetEvent(PageSizeCombo, Self, 'OnChange', 'PageSizeComboChange');
    PageSizeCombo.ItemIndex := -1;
    PageSizeCombo.Items.BeginUpdate;
    try
      PageSizeCombo.Items.Clear;
      PageSizeCombo.Items.Add('10');
      PageSizeCombo.Items.Add('25');
      PageSizeCombo.Items.Add('50');
      PageSizeCombo.Items.Add('100');
      PageSizeCombo.Items.Add('');
    finally
      PageSizeCombo.Items.EndUpdate;
    end;
    PaginationInfo.SetParentComponent(Self);
    PaginationInfo.Name := 'PaginationInfo';
    PaginationInfo.Left := 256;
    PaginationInfo.Top := 403;
    PaginationInfo.Width := 300;
    PaginationInfo.Height := 25;
    PaginationInfo.HeightStyle := ssAuto;
    PaginationInfo.WidthStyle := ssAuto;
    PaginationInfo.HeightPercent := 100.000000000000000000;
    PaginationInfo.WidthPercent := 100.000000000000000000;
    PaginationInfo.ChildOrder := 7;
    PaginationInfo.DefaultItemClassName := 'page-item';
    PaginationInfo.DefaultItemLinkClassName := 'page-link';
    PaginationInfo.ElementListClassName := 'pagination';
    PaginationInfo.Items.Clear;
    with PaginationInfo.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with PaginationInfo.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with PaginationInfo.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    PaginationInfo.Style := lsPagination;
    CloseButton.SetParentComponent(Self);
    CloseButton.Name := 'CloseButton';
    CloseButton.Left := 449;
    CloseButton.Top := 372;
    CloseButton.Width := 96;
    CloseButton.Height := 25;
    CloseButton.Caption := 'Close';
    CloseButton.ChildOrder := 5;
    CloseButton.ElementClassName := 'btn btn-secondary';
    CloseButton.ElementPosition := epIgnore;
    CloseButton.HeightStyle := ssAuto;
    CloseButton.HeightPercent := 100.000000000000000000;
    CloseButton.ModalResult := 1;
    CloseButton.WidthStyle := ssAuto;
    CloseButton.WidthPercent := 100.000000000000000000;
    SetEvent(CloseButton, Self, 'OnClick', 'CloseButtonClick');
    DeleteDonation.SetParentComponent(Self);
    DeleteDonation.Name := 'DeleteDonation';
    DeleteDonation.Left := 584;
    DeleteDonation.Top := 136;
    DeleteDonation.Width := 24;
    DeleteDonation.Height := 24;
    DeleteDonation.HeightStyle := ssAuto;
    DeleteDonation.WidthStyle := ssAuto;
    DeleteDonation.Buttons := [];
    DeleteDonation.Opacity := 0.200000000000000000;
    DeleteDonation.ElementButtonClassName := 'btn';
    DeleteDonation.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    DeleteDonation.ElementTitleClassName := 'text-body';
    DeleteDonation.ElementContentClassName := 'text-body';
    ShowErrorsOnly.SetParentComponent(Self);
    ShowErrorsOnly.Name := 'ShowErrorsOnly';
    ShowErrorsOnly.Left := 432;
    ShowErrorsOnly.Top := 434;
    ShowErrorsOnly.Width := 113;
    ShowErrorsOnly.Height := 22;
    ShowErrorsOnly.Caption := 'Show Errors Only';
    ShowErrorsOnly.ChildOrder := 7;
    ShowErrorsOnly.ElementClassName := 'form-check-input';
    ShowErrorsOnly.ElementPosition := epIgnore;
    ShowErrorsOnly.HeightStyle := ssAuto;
    ShowErrorsOnly.HeightPercent := 100.000000000000000000;
    ShowErrorsOnly.WidthStyle := ssAuto;
    ShowErrorsOnly.WidthPercent := 100.000000000000000000;
    SetEvent(ShowErrorsOnly, Self, 'OnClick', 'ShowErrorsOnlyClick');
    ImportDonationSource.SetParentComponent(Self);
    ImportDonationSource.Name := 'ImportDonationSource';
    ImportDonationSource.DataSet := ImportDonationData;
    ImportDonationSource.Left := 144;
    ImportDonationSource.Top := 8;
    ImportDonationData.SetParentComponent(Self);
    ImportDonationData.Name := 'ImportDonationData';
    ImportDonationData.AfterApplyUpdates := ImportDonationDataAfterApplyUpdates;
    ImportDonationData.AfterPost := ImportDonationDataAfterPost;
    ImportDonationData.AfterDelete := ImportDonationDataAfterDelete;
    ImportDonationData.EntitySetName := 'ImportDonation';
    ImportDonationData.Connection := MainData.DataConnection;
    ImportDonationData.Left := 72;
    ImportDonationData.Top := 8;
    ImportDonationDataId.SetParentComponent(ImportDonationData);
    ImportDonationDataId.Name := 'ImportDonationDataId';
    ImportDonationDataId.FieldName := 'Id';
    ImportDonationDataDateAdded.SetParentComponent(ImportDonationData);
    ImportDonationDataDateAdded.Name := 'ImportDonationDataDateAdded';
    ImportDonationDataDateAdded.FieldName := 'DateAdded';
    ImportDonationDataAddedBy.SetParentComponent(ImportDonationData);
    ImportDonationDataAddedBy.Name := 'ImportDonationDataAddedBy';
    ImportDonationDataAddedBy.FieldName := 'AddedBy';
    ImportDonationDataLastUpdatedBy.SetParentComponent(ImportDonationData);
    ImportDonationDataLastUpdatedBy.Name := 'ImportDonationDataLastUpdatedBy';
    ImportDonationDataLastUpdatedBy.FieldName := 'LastUpdatedBy';
    ImportDonationDataLastUpdated.SetParentComponent(ImportDonationData);
    ImportDonationDataLastUpdated.Name := 'ImportDonationDataLastUpdated';
    ImportDonationDataLastUpdated.FieldName := 'LastUpdated';
    ImportDonationDataTitle.SetParentComponent(ImportDonationData);
    ImportDonationDataTitle.Name := 'ImportDonationDataTitle';
    ImportDonationDataTitle.FieldName := 'Title';
    ImportDonationDataTitle.Size := 25;
    ImportDonationDataFirstName.SetParentComponent(ImportDonationData);
    ImportDonationDataFirstName.Name := 'ImportDonationDataFirstName';
    ImportDonationDataFirstName.FieldName := 'FirstName';
    ImportDonationDataFirstName.Size := 50;
    ImportDonationDataMiddleName.SetParentComponent(ImportDonationData);
    ImportDonationDataMiddleName.Name := 'ImportDonationDataMiddleName';
    ImportDonationDataMiddleName.FieldName := 'MiddleName';
    ImportDonationDataMiddleName.Size := 50;
    ImportDonationDataLastName.SetParentComponent(ImportDonationData);
    ImportDonationDataLastName.Name := 'ImportDonationDataLastName';
    ImportDonationDataLastName.FieldName := 'LastName';
    ImportDonationDataLastName.Size := 50;
    ImportDonationDataSuffix.SetParentComponent(ImportDonationData);
    ImportDonationDataSuffix.Name := 'ImportDonationDataSuffix';
    ImportDonationDataSuffix.FieldName := 'Suffix';
    ImportDonationDataSuffix.Size := 50;
    ImportDonationDataAdd1.SetParentComponent(ImportDonationData);
    ImportDonationDataAdd1.Name := 'ImportDonationDataAdd1';
    ImportDonationDataAdd1.FieldName := 'Add1';
    ImportDonationDataAdd1.Size := 75;
    ImportDonationDataAdd2.SetParentComponent(ImportDonationData);
    ImportDonationDataAdd2.Name := 'ImportDonationDataAdd2';
    ImportDonationDataAdd2.FieldName := 'Add2';
    ImportDonationDataAdd2.Size := 75;
    ImportDonationDataAdd3.SetParentComponent(ImportDonationData);
    ImportDonationDataAdd3.Name := 'ImportDonationDataAdd3';
    ImportDonationDataAdd3.FieldName := 'Add3';
    ImportDonationDataAdd3.Size := 75;
    ImportDonationDataCity.SetParentComponent(ImportDonationData);
    ImportDonationDataCity.Name := 'ImportDonationDataCity';
    ImportDonationDataCity.FieldName := 'City';
    ImportDonationDataCity.Size := 75;
    ImportDonationDataPostCode.SetParentComponent(ImportDonationData);
    ImportDonationDataPostCode.Name := 'ImportDonationDataPostCode';
    ImportDonationDataPostCode.FieldName := 'PostCode';
    ImportDonationDataPostCode.Size := 15;
    ImportDonationDataEmail.SetParentComponent(ImportDonationData);
    ImportDonationDataEmail.Name := 'ImportDonationDataEmail';
    ImportDonationDataEmail.FieldName := 'Email';
    ImportDonationDataEmail.Size := 75;
    ImportDonationDataMobile.SetParentComponent(ImportDonationData);
    ImportDonationDataMobile.Name := 'ImportDonationDataMobile';
    ImportDonationDataMobile.FieldName := 'Mobile';
    ImportDonationDataMobile.Size := 25;
    ImportDonationDataTelephone.SetParentComponent(ImportDonationData);
    ImportDonationDataTelephone.Name := 'ImportDonationDataTelephone';
    ImportDonationDataTelephone.FieldName := 'Telephone';
    ImportDonationDataTelephone.Size := 25;
    ImportDonationDataMatchHash.SetParentComponent(ImportDonationData);
    ImportDonationDataMatchHash.Name := 'ImportDonationDataMatchHash';
    ImportDonationDataMatchHash.FieldName := 'MatchHash';
    ImportDonationDataMatchHash.Size := 64;
    ImportDonationDataContactByPhone.SetParentComponent(ImportDonationData);
    ImportDonationDataContactByPhone.Name := 'ImportDonationDataContactByPhone';
    ImportDonationDataContactByPhone.FieldName := 'ContactByPhone';
    ImportDonationDataContactByPost.SetParentComponent(ImportDonationData);
    ImportDonationDataContactByPost.Name := 'ImportDonationDataContactByPost';
    ImportDonationDataContactByPost.FieldName := 'ContactByPost';
    ImportDonationDataContactByText.SetParentComponent(ImportDonationData);
    ImportDonationDataContactByText.Name := 'ImportDonationDataContactByText';
    ImportDonationDataContactByText.FieldName := 'ContactByText';
    ImportDonationDataContactByEmail.SetParentComponent(ImportDonationData);
    ImportDonationDataContactByEmail.Name := 'ImportDonationDataContactByEmail';
    ImportDonationDataContactByEmail.FieldName := 'ContactByEmail';
    ImportDonationDataDOB.SetParentComponent(ImportDonationData);
    ImportDonationDataDOB.Name := 'ImportDonationDataDOB';
    ImportDonationDataDOB.FieldName := 'DOB';
    ImportDonationDataEmailStatus.SetParentComponent(ImportDonationData);
    ImportDonationDataEmailStatus.Name := 'ImportDonationDataEmailStatus';
    ImportDonationDataEmailStatus.FieldName := 'EmailStatus';
    ImportDonationDataEmailStatus.Size := 10;
    ImportDonationDataLatitude.SetParentComponent(ImportDonationData);
    ImportDonationDataLatitude.Name := 'ImportDonationDataLatitude';
    ImportDonationDataLatitude.FieldName := 'Latitude';
    ImportDonationDataLongitude.SetParentComponent(ImportDonationData);
    ImportDonationDataLongitude.Name := 'ImportDonationDataLongitude';
    ImportDonationDataLongitude.FieldName := 'Longitude';
    ImportDonationDataExternalId.SetParentComponent(ImportDonationData);
    ImportDonationDataExternalId.Name := 'ImportDonationDataExternalId';
    ImportDonationDataExternalId.FieldName := 'ExternalId';
    ImportDonationDataExternalId.Size := 64;
    ImportDonationDataCountryCode.SetParentComponent(ImportDonationData);
    ImportDonationDataCountryCode.Name := 'ImportDonationDataCountryCode';
    ImportDonationDataCountryCode.FieldName := 'CountryCode';
    ImportDonationDataCountryCode.Size := 3;
    ImportDonationDataClaimStatus.SetParentComponent(ImportDonationData);
    ImportDonationDataClaimStatus.Name := 'ImportDonationDataClaimStatus';
    ImportDonationDataClaimStatus.FieldName := 'ClaimStatus';
    ImportDonationDataClaimStatus.Size := 22;
    ImportDonationDataCharityTenant.SetParentComponent(ImportDonationData);
    ImportDonationDataCharityTenant.Name := 'ImportDonationDataCharityTenant';
    ImportDonationDataCharityTenant.FieldName := 'CharityTenant';
    ImportDonationDataImportState.SetParentComponent(ImportDonationData);
    ImportDonationDataImportState.Name := 'ImportDonationDataImportState';
    ImportDonationDataImportState.FieldName := 'ImportState';
    ImportDonationDataImportState.Size := 5;
    ImportDonationDataErrorText.SetParentComponent(ImportDonationData);
    ImportDonationDataErrorText.Name := 'ImportDonationDataErrorText';
    ImportDonationDataErrorText.FieldName := 'ErrorText';
    ImportDonationDataErrorText.Size := 1000;
    ImportDonationDataImportBatchId.SetParentComponent(ImportDonationData);
    ImportDonationDataImportBatchId.Name := 'ImportDonationDataImportBatchId';
    ImportDonationDataImportBatchId.FieldName := 'ImportBatchId';
    ImportDonationDataSponsored.SetParentComponent(ImportDonationData);
    ImportDonationDataSponsored.Name := 'ImportDonationDataSponsored';
    ImportDonationDataSponsored.FieldName := 'Sponsored';
    ImportDonationDataDonationDate.SetParentComponent(ImportDonationData);
    ImportDonationDataDonationDate.Name := 'ImportDonationDataDonationDate';
    ImportDonationDataDonationDate.FieldName := 'DonationDate';
    ImportDonationDataGiftAid.SetParentComponent(ImportDonationData);
    ImportDonationDataGiftAid.Name := 'ImportDonationDataGiftAid';
    ImportDonationDataGiftAid.FieldName := 'GiftAid';
    ImportDonationDataAmount.SetParentComponent(ImportDonationData);
    ImportDonationDataAmount.Name := 'ImportDonationDataAmount';
    ImportDonationDataAmount.FieldName := 'Amount';
    ImportDonationDataAmount.DisplayFormat := '######0.00##';
    ImportDonationDataAmount.currency := True;
    ImportDonationDataExternalDonationId.SetParentComponent(ImportDonationData);
    ImportDonationDataExternalDonationId.Name := 'ImportDonationDataExternalDonationId';
    ImportDonationDataExternalDonationId.FieldName := 'ExternalDonationId';
    ImportDonationDataExternalDonationId.Size := 255;
    ImportDonationDataMatchedPerson.SetParentComponent(ImportDonationData);
    ImportDonationDataMatchedPerson.Name := 'ImportDonationDataMatchedPerson';
    ImportDonationDataMatchedPerson.FieldName := 'MatchedPerson';
    ImportDonationDataHearingStatus.SetParentComponent(ImportDonationData);
    ImportDonationDataHearingStatus.Name := 'ImportDonationDataHearingStatus';
    ImportDonationDataHearingStatus.FieldName := 'HearingStatus';
    ImportDonationDataHearingStatus.Size := 8;
    ImportDonationDataVisualStatus.SetParentComponent(ImportDonationData);
    ImportDonationDataVisualStatus.Name := 'ImportDonationDataVisualStatus';
    ImportDonationDataVisualStatus.FieldName := 'VisualStatus';
    ImportDonationDataVisualStatus.Size := 8;
    ImportDonationDataMobilityStatus.SetParentComponent(ImportDonationData);
    ImportDonationDataMobilityStatus.Name := 'ImportDonationDataMobilityStatus';
    ImportDonationDataMobilityStatus.FieldName := 'MobilityStatus';
    ImportDonationDataMobilityStatus.Size := 8;
    ImportDonationDataSourceType.SetParentComponent(ImportDonationData);
    ImportDonationDataSourceType.Name := 'ImportDonationDataSourceType';
    ImportDonationDataSourceType.FieldName := 'SourceType';
    ImportDonationDataSourceType.Size := 9;
    ImportDonationDataCounty.SetParentComponent(ImportDonationData);
    ImportDonationDataCounty.Name := 'ImportDonationDataCounty';
    ImportDonationDataCounty.FieldName := 'County';
    ImportDonationDataCounty.Size := 75;
    ImportDonationDataImportId.SetParentComponent(ImportDonationData);
    ImportDonationDataImportId.Name := 'ImportDonationDataImportId';
    ImportDonationDataImportId.FieldName := 'ImportId';
    ImportDonationDataCountry.SetParentComponent(ImportDonationData);
    ImportDonationDataCountry.Name := 'ImportDonationDataCountry';
    ImportDonationDataCountry.FieldName := 'Country';
    ImportDonationDataCountry.Size := 75;
  finally
    PaginationInfoLabel.AfterLoadDFMValues;
    ImportDonationsTable.AfterLoadDFMValues;
    PageSizeCombo.AfterLoadDFMValues;
    PaginationInfo.AfterLoadDFMValues;
    CloseButton.AfterLoadDFMValues;
    DeleteDonation.AfterLoadDFMValues;
    ShowErrorsOnly.AfterLoadDFMValues;
    ImportDonationSource.AfterLoadDFMValues;
    ImportDonationData.AfterLoadDFMValues;
    ImportDonationDataId.AfterLoadDFMValues;
    ImportDonationDataDateAdded.AfterLoadDFMValues;
    ImportDonationDataAddedBy.AfterLoadDFMValues;
    ImportDonationDataLastUpdatedBy.AfterLoadDFMValues;
    ImportDonationDataLastUpdated.AfterLoadDFMValues;
    ImportDonationDataTitle.AfterLoadDFMValues;
    ImportDonationDataFirstName.AfterLoadDFMValues;
    ImportDonationDataMiddleName.AfterLoadDFMValues;
    ImportDonationDataLastName.AfterLoadDFMValues;
    ImportDonationDataSuffix.AfterLoadDFMValues;
    ImportDonationDataAdd1.AfterLoadDFMValues;
    ImportDonationDataAdd2.AfterLoadDFMValues;
    ImportDonationDataAdd3.AfterLoadDFMValues;
    ImportDonationDataCity.AfterLoadDFMValues;
    ImportDonationDataPostCode.AfterLoadDFMValues;
    ImportDonationDataEmail.AfterLoadDFMValues;
    ImportDonationDataMobile.AfterLoadDFMValues;
    ImportDonationDataTelephone.AfterLoadDFMValues;
    ImportDonationDataMatchHash.AfterLoadDFMValues;
    ImportDonationDataContactByPhone.AfterLoadDFMValues;
    ImportDonationDataContactByPost.AfterLoadDFMValues;
    ImportDonationDataContactByText.AfterLoadDFMValues;
    ImportDonationDataContactByEmail.AfterLoadDFMValues;
    ImportDonationDataDOB.AfterLoadDFMValues;
    ImportDonationDataEmailStatus.AfterLoadDFMValues;
    ImportDonationDataLatitude.AfterLoadDFMValues;
    ImportDonationDataLongitude.AfterLoadDFMValues;
    ImportDonationDataExternalId.AfterLoadDFMValues;
    ImportDonationDataCountryCode.AfterLoadDFMValues;
    ImportDonationDataClaimStatus.AfterLoadDFMValues;
    ImportDonationDataCharityTenant.AfterLoadDFMValues;
    ImportDonationDataImportState.AfterLoadDFMValues;
    ImportDonationDataErrorText.AfterLoadDFMValues;
    ImportDonationDataImportBatchId.AfterLoadDFMValues;
    ImportDonationDataSponsored.AfterLoadDFMValues;
    ImportDonationDataDonationDate.AfterLoadDFMValues;
    ImportDonationDataGiftAid.AfterLoadDFMValues;
    ImportDonationDataAmount.AfterLoadDFMValues;
    ImportDonationDataExternalDonationId.AfterLoadDFMValues;
    ImportDonationDataMatchedPerson.AfterLoadDFMValues;
    ImportDonationDataHearingStatus.AfterLoadDFMValues;
    ImportDonationDataVisualStatus.AfterLoadDFMValues;
    ImportDonationDataMobilityStatus.AfterLoadDFMValues;
    ImportDonationDataSourceType.AfterLoadDFMValues;
    ImportDonationDataCounty.AfterLoadDFMValues;
    ImportDonationDataImportId.AfterLoadDFMValues;
    ImportDonationDataCountry.AfterLoadDFMValues;
  end;
end;

end.
